
import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface ErrorStateProps {
  type: "empty" | "invalid";
  onRefresh?: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ type, onRefresh }) => {
  if (type === "invalid") {
    return (
      <div className="p-4 text-red-500 flex items-center justify-center space-x-2">
        <AlertTriangle className="h-5 w-5" />
        <span>Geen permissie-data gevonden. Probeer de pagina te verversen.</span>
      </div>
    );
  }

  return (
    <div className="p-4 text-amber-500 flex items-center justify-center space-x-2">
      <AlertTriangle className="h-5 w-5" />
      <span>Geen rollen gevonden in de permissie-data.</span>
      {onRefresh && (
        <Button 
          variant="outline" 
          className="ml-4"
          onClick={onRefresh}
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Pagina herladen
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
